import {
  INDICATOR_LOAD_ATTEMPT,
  INDICATOR_LOAD_SUCCESS,
  INDICATOR_LOAD_FAILED,
} from "../types/indicatorTypes";

const INITIAL_STATE = {
  loading: false,
  period: "month",
  item: {
    Sales: 0,
    Rents: 0,
    Exchanges: 0,
    Donations: 0,
    Auctions: 0,
  },
  error: "",
};

function indicator(state = INITIAL_STATE, action) {
  switch (action.type) {
    case INDICATOR_LOAD_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case INDICATOR_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        period: action.data.Period || state.period,
        item: {
          Sales: action.data.Sales || 0,
          Rents: action.data.Rents || 0,
          Exchanges: action.data.Exchanges || 0,
          Donations: action.data.Donations || 0,
          Auctions: action.data.Auctions || 0,
        },
        error: "",
      };

    case INDICATOR_LOAD_FAILED:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
}

export default indicator;
